export const storeRegister = {
  registered: false,
  register() {
    this.registered = true;
  },
};
